import type { CSSProperties, ReactNode } from "react";
import { Column, Row } from "@react-email/components";

export const FeatureList = ({
  description,
  image,
  style,
}: {
  description: ReactNode;
  image: ReactNode;
  style?: CSSProperties;
}) => (
  <Row style={style}>
    <Column style={{ verticalAlign: "top", height: "48px", width: "48px" }}>
      {image}
    </Column>
    <Column>{description}</Column>
  </Row>
);
